import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Card, OverlayTrigger, Tooltip, Modal, Form, Dropdown } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import Switch from "react-switch";

//ACTION
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";
import * as PdfLibraryActions from "../../../../envStore/actions/pdfLibrary";

//STYLES
import * as ControllerStyles from "../styles/controller";

function Controller() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const pdfLibrary = useSelector((state) => state.pdfLibrary);

    const [pdfs, setPdfs] = useState([]);
    const [directoryExist, setDirectoryExist] = useState(true);
    const [libraries, setLibraries] = useState([]);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("PDF Library"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("PDF Library"));

        handleLoadLibraries();
        if (pdfLibrary.library.name != "library") {
            fetchPDFsFromLibrary(pdfLibrary.library.uuid);
        }
    }, []);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const [modal, setModal] = useState({
        open: false,
        header: "",
        message: ""
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const [settingsModal, setSettingsModal] = useState({
        open: false,
        headings: false,
        dates: false
    });

    function handleSettingsModalClose() {
        setSettingsModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const addLibraryModalDefaults = {
        open: false,
        value: "",
        valid: true
    };

    const [addLibraryModal, setAddLibraryModal] = useState(addLibraryModalDefaults);

    function handleAddLibraryModalClose() {
        setAddLibraryModal(addLibraryModalDefaults);
    }

    function handleLoadLibraries() {
        Axios.post("/pods/pdfLibrary/loadLibraries")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setLibraries(data.libraries);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleAddPDF() {
        navigate("./upload");
    }

    function handleDeleteButton(id) {
        setModalYN({
            heading: "Delete PDF",
            message: "Are you sure you want to delete this PDF?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: acceptDelete.bind(this, id),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function acceptDelete(id) {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });

        const data = { id: id, getPDFs: true };
        Axios.post("/pods/pdfLibrary/deletePDF", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setPdfs(data.pdfs);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleEditItem(id) {
        navigate(`./modify/${id}`);
    }

    function handleOpenSettings() {
        Axios.post("/pods/pdfLibrary/loadSettings")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    console.log(data.settings);
                    const heading = data.settings.find((set) => set.setting == "headings").value;
                    const date = data.settings.find((set) => set.setting == "dates").value;

                    setSettingsModal((prevState) => {
                        return { ...prevState, headings: heading == "true", dates: date == "true", open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleSwitchChange(name, checked) {
        const data = { setting: name, value: checked.toString() };
        Axios.post("/pods/pdfLibrary/updateSetting", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setSettingsModal((prevState) => {
                        return { ...prevState, [name]: checked };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenAddLibraryModal() {
        setAddLibraryModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    function handleAddLibrarySubmit() {
        if (addLibraryModal.value == "") {
            setAddLibraryModal((prevState) => {
                return { ...prevState, valid: false };
            });
        } else {
            const data = { name: addLibraryModal.value };
            Axios.post("/pods/pdfLibrary/addLibrary", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setAddLibraryModal(addLibraryModalDefaults);
                        handleLoadLibraries();
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleAddModalTextChange(event) {
        const { value } = event.target;

        setAddLibraryModal((prevState) => {
            return { ...prevState, value };
        });
    }

    function handleSelectALibrary(library) {
        dispatch(PdfLibraryActions.UpdateLibrary({ name: library.name, uuid: library.uuid }));
        fetchPDFsFromLibrary(library.uuid);
    }

    function fetchPDFsFromLibrary(library) {
        const data = { library: library };
        Axios.post("/pods/pdfLibrary/getAllPDFsFromLibrary", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    if (!data.dirExist) {
                        setDirectoryExist(false);
                    } else {
                        setPdfs(data.pdfs);
                    }
                }
            })
            .catch((err) => console.log(err));
    }

    function handleDeleteLibrary() {
        const data = { library: pdfLibrary.library };
        Axios.post("/pods/pdfLibrary/checkForFilesBeforeDeletingLibrary", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "Yes") {
                    setModal({ header: "PDF Library", message: data.message, open: true });
                } else {
                    setModalYN({
                        heading: "Delete Library",
                        message: "Are you sure you want to delete this Library?",
                        showAccept: true,
                        acceptName: "Yes",
                        acceptFunction: handleAcceptLibraryDelete,
                        showCancel: true,
                        cancelName: "No",
                        open: true
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleAcceptLibraryDelete() {
        const data = { library: pdfLibrary.library };
        Axios.post("/pods/pdfLibrary/deleteLibrary", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    dispatch(PdfLibraryActions.UpdateLibrary({ name: "library", uuid: 0 }));
                    handleLoadLibraries();

                    setModalYN((prevState) => {
                        return { ...prevState, open: false };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={ControllerStyles.body}>
            {directoryExist ? (
                <div>
                    <Row>
                        <Col style={ControllerStyles.topRow}>
                            <Button onClick={handleOpenAddLibraryModal}>Add Library</Button>
                            <Dropdown>
                                <Dropdown.Toggle>{pdfLibrary.library.name}</Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {libraries.map((library, index) => {
                                        return (
                                            <Dropdown.Item key={index} onClick={handleSelectALibrary.bind(this, library)}>
                                                {library.name}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                            {pdfLibrary.library.name != "library" && (
                                <div style={ControllerStyles.topRow}>
                                    <Button onClick={handleAddPDF}>Add PDF</Button>
                                    <Button onClick={handleDeleteLibrary}>Delete Library</Button>
                                </div>
                            )}
                        </Col>
                        <Col sm={2} style={ControllerStyles.rightColumn}>
                            <Button onClick={handleOpenSettings}>Settings</Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col style={ControllerStyles.container}>
                            {pdfs.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Card style={ControllerStyles.cardStyle}>
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={2}>{item.name}</Col>
                                                    <Col sm={2}>{item.date}</Col>
                                                    <Col sm={4}>{item.filename}</Col>
                                                    <Col sm={2}>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                            <Button variant="warning" onClick={handleEditItem.bind(this, item.uuid)}>
                                                                <i className="fa-solid fa-pen-to-square"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                            <Button variant="danger" onClick={handleDeleteButton.bind(this, item.uuid)}>
                                                                <i className="fa-solid fa-trash-can"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                        <br />
                                    </div>
                                );
                            })}
                        </Col>
                    </Row>
                    <Modal show={modal.open} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{modal.header}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{modal.message}</Modal.Body>
                        <Modal.Footer>
                            <Button onClick={handleCloseModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={modalYN.open} onHide={handleModalYNClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalYN.heading}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{modalYN.message}</Modal.Body>
                        <Modal.Footer>
                            {modalYN.showAccept ? (
                                <div>
                                    <Button variant="primary" onClick={modalYN.acceptFunction}>
                                        {modalYN.acceptName}
                                    </Button>
                                </div>
                            ) : null}
                            {modalYN.showCancel ? (
                                <div>
                                    <Button variant="primary" onClick={handleModalYNClose}>
                                        {modalYN.cancelName}
                                    </Button>
                                </div>
                            ) : null}
                        </Modal.Footer>
                    </Modal>
                    <Modal show={settingsModal.open} onHide={handleSettingsModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Settings</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col style={ControllerStyles.settingsTitles}>Show Headings:</Col>
                                <Col>
                                    <Switch
                                        className="customCSS-Content-New-Item-Switch"
                                        onChange={handleSwitchChange.bind(this, "headings")}
                                        checked={settingsModal.headings}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col style={ControllerStyles.settingsTitles}>Show Dates:</Col>
                                <Col>
                                    <Switch
                                        className="customCSS-Content-New-Item-Switch"
                                        onChange={handleSwitchChange.bind(this, "dates")}
                                        checked={settingsModal.dates}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={handleSettingsModalClose}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={addLibraryModal.open} onHide={handleAddLibraryModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Library</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label>Name:</Form.Label>
                                <Form.Control
                                    isInvalid={!addLibraryModal.valid}
                                    type="text"
                                    value={addLibraryModal.value}
                                    onChange={handleAddModalTextChange}
                                    maxLength={50}
                                />
                                <div style={ControllerStyles.counter}>{50 - addLibraryModal.value.length}/50</div>
                                <Form.Control.Feedback type="invalid">Please enter a name!</Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={handleAddLibrarySubmit}>Add</Button>
                            <Button onClick={handleAddLibraryModalClose}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            ) : (
                <div style={ControllerStyles.errorMessage}>
                    <br />
                    <p>The Pod&#39;s resource folder and/or the global temp folder does not exist, please contact High-View Studios</p>
                </div>
            )}
        </div>
    );
}

export default Controller;
